import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeCommentCommand extends BaseCommand {
  CommandName = "ChangeComment";
  Command: {
    Value: string;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Value: value };
  }
}
